import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8f1fbb42&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=8f1fbb42&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1fbb42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f1fbb42')) {
      api.createRecord('8f1fbb42', component.options)
    } else {
      api.reload('8f1fbb42', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8f1fbb42&scoped=true", function () {
      api.rerender('8f1fbb42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/wrong/index.vue"
export default component.exports